<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="pen-edit.9"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="Group_728" data-name="Group 728" transform="translate(3 4)">
      <path
        id="Path_8092"
        data-name="Path 8092"
        d="M19,12h1a1,1,0,0,1,1,1v6a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V13a1,1,0,0,1,1-1H5M15,6l3,3"
        transform="translate(-3 -4)"
        fill="none"
        :stroke="clr ? clr : '#56606b'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_8093"
        data-name="Path 8093"
        d="M16.707,4.293,9.241,11.759a1,1,0,0,0-.293.707V15h2.637a1,1,0,0,0,.707-.293l7.414-7.414a1,1,0,0,0,0-1.414L18.12,4.293a1,1,0,0,0-1.413,0Z"
        transform="translate(-3 -4)"
        fill="none"
        :stroke="clr ? clr : '#56606b'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <path id="Path_8094" data-name="Path 8094" d="M0,0H24V24H0Z" fill="none" />
  </svg>
</template>
